import { Link } from '@tanstack/react-router';
import { PLATFORM_APPS, type AppSlug } from '@k-os/core';
import { AppIcon } from '../components/AppIcon';
import styles from './AppSelector.module.css';

const APPS: Array<{
  slug: AppSlug;
  name: string;
  routeBase: '/tasks' | '/health' | '/finance';
  description: string;
  status: string;
}> = [
  {
    ...PLATFORM_APPS.tasks,
    name: 'Tasks',
    routeBase: '/tasks',
  },
  {
    ...PLATFORM_APPS.health,
    name: 'Health',
    routeBase: '/health',
  },
  {
    ...PLATFORM_APPS.finance,
    name: 'Finance',
    routeBase: '/finance',
  },
];

export function AppSelectorScreen() {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div>
          <h2 className={styles.title}>Applications</h2>
          <p className={styles.sub}>Choose the area you want to work in.</p>
        </div>
      </header>

      <section className={styles.grid} aria-label="K-OS applications">
        {APPS.map((app) => (
          <Link to={app.routeBase} className={styles.card} key={app.slug}>
            <span className={styles.icon}>
              <AppIcon slug={app.slug} size={60} />
            </span>
            <span className={styles.body}>
              <span className={styles.cardTitle}>{app.name}</span>
              <span className={styles.cardDetail}>{app.description}</span>
            </span>
            <span className={styles.status}>{app.status}</span>
          </Link>
        ))}
      </section>
    </div>
  );
}
